import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { TableDataModel } from 'src/app/shared/models/CommandCenterUI/TableDataModel.model';

@Component({
	selector: 'app-table-data-model-list',
	templateUrl: './table-data-model-list.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class TableDataModelListComponent implements OnInit {
	tableModelList: TableDataModel[];

	tableModelSelected: TableDataModel;

	isAdding: boolean = false;

	constructor(public app: AppService, public focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.focuslink.adminCommandCenterTableModelGetAll().then(
			(data) =>
				(this.tableModelList = data.map((i) => {
					const model = new TableDataModel(i);
					model.name = model.sk.replace('MODEL_', '');
					return model;
				}))
		);
	}

	add() {
		this.tableModelSelected = new TableDataModel();
		this.isAdding = true;
	}

	tableModelSaved(tableModel: TableDataModel) {
		this.isAdding = false;
		this.tableModelList[this.tableModelList.findIndex((i) => i.sk === tableModel.sk)] = tableModel;
		this.tableModelList = [...this.tableModelList];
	}
}
